import Vue from 'vue'
import VueRouter from 'vue-router'

//课程
import index from '../views/index.vue'
import rank from '../views/rank.vue'
import show from '../views/show.vue'
import reg from '../views/reg.vue'
import myCenter from '../views/myCenter.vue'
import history from '../views/history.vue'


//学习
import store from '@/store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: 'index',
    component: index,
    meta: {
      title: '激情世界杯 一起来助威'
    }
  },
  {
    path: '/reg',
    name: 'reg',
    component: reg,
    meta: {
      title: '登记信息'
    }
  },
  {
    path: '/rank',
    name: 'rank',
    component: rank,
    meta: {
      title: '排行榜'
    }
  },
  {
    path: '/show',
    name: 'show',
    component: show,
    meta: {
      title: '课程'
    }
  },
  {
    path: '/mycenter',
    name: 'mycenter',
    component: myCenter,
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/history',
    name: 'history',
    component: history,
    meta: {
      title: '学习进度'
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: '/webpage/guess_world_cup/', //配置二级目录  
  routes
})

//解决重复点击相同路由报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

//全局前置守卫
router.beforeEach((to, from, next) => {

  if (to.meta.title) {
    document.title = to.meta.title
  }
  let accountId = store.state.accountId;
  let uniqueId = store.state.uniqueId;


  if (to.path !== "/index") {
    if (!accountId || !uniqueId) {
      next({ path: '/index?app_control=1101', query: to.query });
    } else {
      //全局添加参数app_control=1101
      if (to.query.app_control === undefined) {
        const app_control = { ...to.query, app_control: '1101' };
        next({ ...to, query: app_control });
      } else {
        next();
      }

    }
  } else {
    //全局添加参数app_control=1101
    if (to.query.app_control === undefined) {
      const app_control = { ...to.query, app_control: '1101' };
      next({ ...to, query: app_control });
    } else {
      next();
    }
  }

})

export default router
